/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Assigned_To_LabelInputs */

const en_explorer_thumbnail_assigned_to_label = /** @type {(inputs: Explorer_Thumbnail_Assigned_To_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigned To:`)
};

const fr_explorer_thumbnail_assigned_to_label = /** @type {(inputs: Explorer_Thumbnail_Assigned_To_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigne a :`)
};

const de_explorer_thumbnail_assigned_to_label = /** @type {(inputs: Explorer_Thumbnail_Assigned_To_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugewiesen an:`)
};

const it_explorer_thumbnail_assigned_to_label = /** @type {(inputs: Explorer_Thumbnail_Assigned_To_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assegnato a:`)
};

const ru_explorer_thumbnail_assigned_to_label = /** @type {(inputs: Explorer_Thumbnail_Assigned_To_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назначено:`)
};

const es_explorer_thumbnail_assigned_to_label = /** @type {(inputs: Explorer_Thumbnail_Assigned_To_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignado a:`)
};

const zh_cn2_explorer_thumbnail_assigned_to_label = /** @type {(inputs: Explorer_Thumbnail_Assigned_To_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指派给：`)
};

const ja_explorer_thumbnail_assigned_to_label = /** @type {(inputs: Explorer_Thumbnail_Assigned_To_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`担当者:`)
};

const hi_explorer_thumbnail_assigned_to_label = /** @type {(inputs: Explorer_Thumbnail_Assigned_To_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`को सौंपना:`)
};

const pt_pt2_explorer_thumbnail_assigned_to_label = /** @type {(inputs: Explorer_Thumbnail_Assigned_To_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atribuído a:`)
};

/**
* | output |
* | --- |
* | "Assigned To:" |
*
* @param {Explorer_Thumbnail_Assigned_To_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_assigned_to_label = /** @type {((inputs?: Explorer_Thumbnail_Assigned_To_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Assigned_To_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_assigned_to_label(inputs)
	if (locale === "de") return de_explorer_thumbnail_assigned_to_label(inputs)
	if (locale === "it") return it_explorer_thumbnail_assigned_to_label(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_assigned_to_label(inputs)
	if (locale === "es") return es_explorer_thumbnail_assigned_to_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_assigned_to_label(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_assigned_to_label(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_assigned_to_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_assigned_to_label(inputs)
	return en_explorer_thumbnail_assigned_to_label(inputs)
});